import $ from 'jquery'
import postContentSize from './content_size'

// BED-94: a segment's room for text comes from its own start and end, so the width changes without
// the text being touched. Every check therefore posts all segments at once and the answer decides
// which of the error lines are shown — exactly like the stories editor.
const SEGMENT_SELECTOR = "[id^='timeline_card_segment_'][id$='_title']"

function segmentIndexes() {
  return $(SEGMENT_SELECTOR).map(function() {
    return this.id.replace(/^timeline_card_segment_/, "").replace(/_title$/, "")
  }).get()
}

function checkSegments() {
  var data = { decision_helper_id: $('#decision_helper_id').val(), segments: {} }

  segmentIndexes().forEach(function(index) {
    data.segments[index] = {
      title: $('#timeline_card_segment_' + index + '_title').val(),
      start: $('#timeline_card_segment_' + index + '_start').val(),
      end: $('#timeline_card_segment_' + index + '_end').val()
    }
  })

  postContentSize("timeline_segments", "/content_size/timeline_card", data)
    .done(function(response) {
      var failing = (response["errors"] || []).map(String)

      segmentIndexes().forEach(function(index) {
        var error = $('#timeline_card_segment_' + index + '_title_error')
        if (failing.indexOf(index) === -1) {
          error.hide()
        } else {
          error.show()
        }
      })
    })
}

$(SEGMENT_SELECTOR).on("change keyup paste", checkSegments)
$("[id^='timeline_card_segment_'][id$='_start'], [id^='timeline_card_segment_'][id$='_end']")
  .on("change", checkSegments)
